module.exports = __webpack_public_path__ + "media/richter.472375f5.wav";